import React, { FC, ReactElement, useState } from 'react'
import { Table, Button } from 'antd'
import { Requests, apiCall } from '../../../api'
import { ErrorsTableProps, DocumentError } from './types'
import PreviewRemoteDocument from '../../PreviewRemoteDocument/PreviewRemoteDocument'

export const ErrorsTable: FC<ErrorsTableProps> = ({ errors, hasAutomatedReview, orderId }): ReactElement => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)
  const [previewName, setPreviewName] = useState<string | null>(null)
  const [previewPage, setPreviewPage] = useState<number | undefined>(undefined)

  const handleDocumentPreview = async (remoteDocumentId: string, documentName: string, pageNumber?: number) => {
    try {
      const request = Requests.titleQCReportDownloadDocument({ orderId, remoteDocumentId })
      const response = await apiCall.get(request.path, { params: request.params })
      setPreviewName(documentName)
      setPreviewUrl(response.data.download_url)
      setPreviewPage(pageNumber)
    } catch (error) {
      console.error('Failed to fetch document preview URL:', error)
    }
  }

  const handleClosePreview = () => {
    setPreviewUrl(null)
    setPreviewName(null)
    setPreviewPage(undefined)
  }

  const columns = [
    {
      title: 'Document',
      dataIndex: 'documentName',
      render: (documentName: string, error: DocumentError) => (
        <div>
          {error.remoteDocumentId ? (
            <Button
              type="link"
              onClick={() => handleDocumentPreview(error.remoteDocumentId!, documentName, error.pageNumber)}
              style={{ padding: 0 }}
            >
              {documentName}
            </Button>
          ) : (
            documentName
          )}
        </div>
      )
    },
    {
      title: 'Error',
      dataIndex: 'error'
    }
  ]

  if (!hasAutomatedReview) {
    columns.push({
      title: 'Scanback',
      dataIndex: 'scanbackPage',
      render: (_: any, error: DocumentError) => (
        <>{error.scanbackPage && error.scanbackName && `Page ${error.scanbackPage} of ${error.scanbackName}`}</>
      )
    })
  }

  const getRowKey = (error: DocumentError) => errors.indexOf(error)

  return (
    <>
      <Table columns={columns} dataSource={errors} pagination={false} rowKey={getRowKey} />
      <PreviewRemoteDocument
        open={!!previewUrl}
        documentName={previewName || ''}
        pdfUrl={previewUrl || ''}
        pageNumber={previewPage}
        onClose={handleClosePreview}
      />
    </>
  )
}

export default ErrorsTable
